import handleMethod from '../Utils/APIutils/handleMethod';

class GatewayContagemAPI {
  async listClients(page = 1, itemsPerPage = 100) {
    return handleMethod({
      type: 'GET',
      method: `api/gatewaycontagem/clients?page=${page}&itemsPerPage=${itemsPerPage}`,
      params: {},
    });
  }

  async listStoresByClient(clientId) {
    return handleMethod({
      type: 'GET',
      method: `api/gatewaycontagem/stores/by-client/${clientId}`,
      params: {},
    });
  }
}

export const gatewayContagemAPI = new GatewayContagemAPI();
